import React from "react";
import { CalendarOutlined, ClockCircleOutlined, CloseCircleOutlined, HourglassOutlined } from "@ant-design/icons";

export enum EAIReminderTiming {
  nothing = "0",
  oneday = "24",
  twodays = "48",
  oneweek = "168",
  twoweeks = "360",
  onemonth = "720"
}

export const aiReminderTimingAsString = (aiReminderTiming: EAIReminderTiming): string => {
  switch (aiReminderTiming) {
    case EAIReminderTiming.nothing:
      return "Pas de relance";
    case EAIReminderTiming.oneday:
      return "24 heures";
    case EAIReminderTiming.twodays:
      return "48 heures";
    case EAIReminderTiming.oneweek:
      return "1 semaine";
    case EAIReminderTiming.twoweeks:
      return "2 semaines";
    case EAIReminderTiming.onemonth:
      return "1 mois";
    default:
      return "";
  }
};

export const renderReminderTimingOption = (
  aiReminderTiming: EAIReminderTiming
): React.ReactNode => {
  // Keep domain enums UI-agnostic; render icons at presentation layer only.
  switch (aiReminderTiming) {
    case EAIReminderTiming.nothing:
      return (
        <>
          <CloseCircleOutlined style={{ marginRight: 6 }} />
          {aiReminderTimingAsString(aiReminderTiming)}
        </>
      );
    case EAIReminderTiming.oneday:
    case EAIReminderTiming.twodays:
      return (
        <>
          <HourglassOutlined style={{ marginRight: 6 }} />
          {aiReminderTimingAsString(aiReminderTiming)}
        </>
      );
    case EAIReminderTiming.oneweek:
    case EAIReminderTiming.twoweeks:
      return (
        <>
          <ClockCircleOutlined style={{ marginRight: 6 }} />
          {aiReminderTimingAsString(aiReminderTiming)}
        </>
      );
    case EAIReminderTiming.onemonth:
      return (
        <>
          <CalendarOutlined style={{ marginRight: 6 }} />
          {aiReminderTimingAsString(aiReminderTiming)}
        </>
      );
    default:
      return aiReminderTimingAsString(aiReminderTiming);
  }
};